import { Col, Container, Row } from 'react-bootstrap';
import Overlap from '../../../Litho/Components/Overlap/Overlap';
import IconWithText from '../../../Litho/Components/IconWithText/IconWithText';
import { fadeIn } from '../../../Litho/Functions/GlobalAnimations';

const featureData = [
	{
		title: 'FCL & LCL',
		content: 'Full and consolidated container services.',
		icon: 'line-icon-Box-Close',
	},
	{
		title: 'Door-to-door',
		content: 'Pickup to final delivery across borders.',
		icon: 'line-icon-Home-2',
	},
	{
		title: 'Customs & documents',
		content: 'Brokerage and compliance support.',
		icon: 'line-icon-Paper',
	},
	{
		title: 'Reefer & special cargo',
		content: 'Temperature-controlled and OOG.',
		icon: 'line-icon-Temperature-3',
	},
	{
		title: 'Schedule visibility',
		content: 'Sailing schedules and milestone tracking.',
		icon: 'line-icon-Calendar',
	},
	{
		title: 'Global network',
		content: 'Carrier partnerships across trades.',
		icon: 'line-icon-Globe',
	},
];

const FeaturesCounters = () => {
	return (
		<section className='overflow-visible bg-lightgray  md:py-[75px] sm:py-[50px] mt-36'>
			<Container>
				<Overlap className='mb-32 sm:mb-28 md:mt-0'>
					<Row className='justify-center'>
						<Col md={12} sm={8}>
							<IconWithText
								grid='row-cols-1 row-cols-lg-3 row-cols-md-2 gap-y-10'
								theme='icon-with-text-11'
								data={featureData}
								animationDelay={0.2}
								animation={fadeIn}
							/>
						</Col>
					</Row>
				</Overlap>
			</Container>
		</section>
	);
};

export default FeaturesCounters;
